import {
  REQUEST as req, RESPONSE as res, FAILURE as fail, CLEAR as clr,
} from '../../actions/trainings/download';

const initialState = {
  response: null,   // { download_url, filename, format, expires_in_seconds, training_id }
  isLoading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:  return { ...initialState, isLoading: true };
    case res:  return { ...state, isLoading: false, response: action.payload };
    case fail: return { ...state, isLoading: false, error: action.payload };
    case clr:  return initialState;
    default:   return state;
  }
};
